import { initStandard, setStandard } from '@modules/standard';
import { useDispatch } from '@stores';
import { IStoreStandard } from '@types';
import { useCallback } from 'react';

const useStandardActions = () => {
  const dispatch = useDispatch();

  const onInitStandard = useCallback(() => {
    dispatch(initStandard());
  }, [dispatch]);

  const onSetStandard = useCallback(
    (payload: Partial<IStoreStandard>) => {
      dispatch(setStandard(payload));
    },
    [dispatch]
  );

  return { onInitStandard, onSetStandard };
};

export default useStandardActions;
